if( _.includes(window.location, "scheda_controllo" ) ) {
    $(document).ready(function() {
        
    });
}
